import React, { useState } from 'react';
import { Tabs, Table, Card, Alert, Select, Radio, Space } from 'antd';
import { DollarOutlined } from '@ant-design/icons';
import { FBA_DATA, Site, ProductType } from '../../../utils/fbaFeeData';

const { TabPane } = Tabs;
const { Option } = Select;



export const FBAFeeConfig: React.FC = () => {
    const [activeSite, setActiveSite] = useState<Site>('US');
    const [productType, setProductType] = useState<ProductType>('standard');
    const [viewMode, setViewMode] = useState<'standard' | 'lowPrice'>('standard');

    const currentSiteConfig = FBA_DATA[activeSite];

    // 获取当前展示的费率表
    let currentTiers = currentSiteConfig.sizeTiers.standard;
    let isLowPriceTable = false;

    if (productType === 'dangerous_goods' && currentSiteConfig.sizeTiers.dangerous) {
        currentTiers = currentSiteConfig.sizeTiers.dangerous;
    } else if (productType === 'apparel' && currentSiteConfig.sizeTiers.apparel) {
        currentTiers = currentSiteConfig.sizeTiers.apparel;
    } else if (viewMode === 'lowPrice' && currentSiteConfig.sizeTiers.lowPrice.length > 0) {
        currentTiers = currentSiteConfig.sizeTiers.lowPrice;
        isLowPriceTable = true;
    }

    const columns = [
        { title: '尺寸分段 (Tier)', dataIndex: 'tierName', key: 'tierName', width: '35%' },
        {
            title: '重量限制',
            key: 'weight',
            render: (_: any, record: any) => {
                if (record.unit === 'oz') {
                    return <span>{record.maxWeight.toFixed(3)} kg <span style={{ color: '#999' }}>(≈{(record.maxWeight / 0.0283495).toFixed(1)}oz)</span></span>;
                }
                if (record.unit === 'lb') {
                    return <span>{record.maxWeight.toFixed(2)} kg <span style={{ color: '#999' }}>(≈{(record.maxWeight / 0.453592).toFixed(1)}lb)</span></span>;
                }
                if (record.unit === 'g') {
                    return <span>{(record.maxWeight < 1 ? record.maxWeight * 1000 : record.maxWeight).toFixed(0)}{record.maxWeight < 1 ? 'g' : 'kg'}</span>;
                }
                return `${record.maxWeight} kg`;
            }
        },
        {
            title: '最大尺寸限制 (cm)',
            key: 'dimensions',
            render: (_: any, record: any) => (
                <span style={{ fontSize: 12 }}>
                    {record.maxEdge[0].toFixed(1)} x {record.maxEdge[1].toFixed(1)} x {record.maxEdge[2].toFixed(1)}
                </span>
            )
        },
        {
            title: `配送费 (${currentSiteConfig.currency})`,
            dataIndex: 'fee',
            key: 'fee',
            render: (text: any) => <span style={{ fontWeight: 600, color: '#1890ff' }}>{text}</span>
        },
    ];

    return (
        <div className="fba-fee-config">
            <Alert
                message="FBA 费率配置 (2024/2025)"
                description={
                    <div>
                        此处显示各站点的最新FBA配送费。系统已内置 <b>低价FBA费率</b>、<b>服装类</b> 和 <b>危险品</b> 的特殊费率。
                        <br />
                        在SKU定价页面，系统将根据您输入的产品尺寸、重量和目标售价，自动匹配最优惠的费率。
                    </div>
                }
                type="info"
                showIcon
                style={{ marginBottom: 16 }}
            />

            <Tabs activeKey={activeSite} onChange={(k) => setActiveSite(k as Site)} type="card">
                {Object.keys(FBA_DATA).map(site => (
                    <TabPane tab={site} key={site} />
                ))}
            </Tabs>

            <Card
                title={<span><DollarOutlined /> FBA 配送费表</span>}
                size="small"
                extra={
                    <Space>
                        <Select value={productType} onChange={setProductType} style={{ width: 120 }}>
                            <Option value="standard">标准商品</Option>
                            <Option value="apparel">服装鞋靴</Option>
                            <Option value="dangerous_goods">危险品</Option>
                        </Select>

                        {productType === 'standard' && currentSiteConfig.sizeTiers.lowPrice.length > 0 && (
                            <Radio.Group value={viewMode} onChange={e => setViewMode(e.target.value)} buttonStyle="solid">
                                <Radio.Button value="standard">标准费率</Radio.Button>
                                <Radio.Button value="lowPrice">低价费率 ({currentSiteConfig.currency}{currentSiteConfig.lowPriceThreshold}以下)</Radio.Button>
                            </Radio.Group>
                        )}
                    </Space>
                }
            >
                {isLowPriceTable && (
                    <Alert
                        message={`当前显示低价FBA费率 (售价 <= ${currentSiteConfig.currency}${currentSiteConfig.lowPriceThreshold})`}
                        type="success"
                        showIcon
                        style={{ marginBottom: 12 }}
                    />
                )}

                <Table
                    dataSource={currentTiers}
                    columns={columns}
                    pagination={false}
                    size="small"
                    bordered
                    rowKey="tierName"
                />
            </Card>
        </div>
    );
};
